export function naturalCompare(a, b) {
    const ax = [];
    const bx = [];

    a.toString().replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
        ax.push([$1 || Infinity, $2 || '']);
        return '';
    });
    b.toString().replace(/(\d+)|(\D+)/g, (_, $1, $2) => {
        bx.push([$1 || Infinity, $2 || '']);
        return '';
    });

    while (ax.length && bx.length) {
        const an = ax.shift();
        const bn = bx.shift();
        const nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
        if (nn) {
            return nn;
        }
    }

    return ax.length - bx.length;
}

export function numberWithSpaces(x = '') {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function declOfNum(num, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[(num % 100 > 4 && num % 100 < 20)
        ? 2
        : cases[(num % 10 < 5) ? num % 10 : 5]
        ];
}


// WEBPACK FOOTER //
// ./src/helpers.js